// extracted by mini-css-extract-plugin
export default {"articleTitle":"noticeModule_articleTitle__geJTj","row":"noticeModule_row__J8te3"};